export default __webpack_public_path__ + "static/media/WAS0030.34I-35112_-20195_0.0abb5a3c.jpg";